import cn from 'classnames'

const Tooltip = ({ text, children, relative }) => {
  return (
    <div className={cn('tooltip', { '-relative': relative })}>
      {children}
      <span className="tooltip__text">{text}</span>
    </div>
  )
}

export default Tooltip
